import { render } from "./OrganizationInfo.vue?vue&type=template&id=65c426bc"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__